import React, { useEffect, useState } from "react";
import clsx from "clsx";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import M_DataStateRenderer from "../../../Molecules/Common/DataStateRenderer/M_DataStateRenderer.jsx";
import LoaderSkeleton from "../../../Molecules/Common/LoaderSkeleton";
import StatusTag from "./StatusTag";
import { getFormattedDate } from "../../../../../Utils/Helpers/dateUtils";
import { api } from "./ProfessionalContacts.helper";
import useStyles from "./ProfessionalContacts.styles";

const ACTION_TONE = { Insert: "valid", Update: "neutral", Delete: "danger" };

const AuditLogView = () => {
  const classes = useStyles();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .listAudit({})
      .then(setEntries)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className={classes.title}>Audit log</h1>
      <div className={classes.subtle}>
        Every add, edit and delete to a firm, contact, address or bank account is recorded, with who and when (DF155-161).
      </div>
      <div className={clsx(classes.tableContainer, classes.tableSpaced)}>
        <M_DataStateRenderer
          loading={loading}
          error={error}
          data={entries}
          isEmpty={!loading && !error && entries.length === 0}
          emptyMessage="No audit history yet."
          skeleton={<LoaderSkeleton />}
        >
          <Table
            size="small"
            className={clsx(classes.table, classes.tableWide)}
          >
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell>When</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Entity</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Detail</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBody}>
              {entries.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell className={classes.cellNowrap}>
                    {}
                    {getFormattedDate(entry.timestampUtc, "DD/MM/YYYY, HH:mm")}
                  </TableCell>
                  <TableCell>{entry.user}</TableCell>
                  <TableCell>
                    <StatusTag tone="neutral">{entry.entity}</StatusTag>
                  </TableCell>
                  <TableCell>
                    <StatusTag tone={ACTION_TONE[entry.action] || "neutral"}>
                      {entry.action}
                    </StatusTag>
                  </TableCell>
                  <TableCell>{entry.detail}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </M_DataStateRenderer>
      </div>
    </div>
  );
};

export default AuditLogView;
